import { IS_LOCAL } from '../../../constants'
import { useAxios } from 'hooks/useAxios'
import { useState } from 'react'
import { useSetRecoilState } from 'recoil'
import { addAlertQuery, AlertType } from 'services/alert'
import timeoutResult from 'shared/http/timeoutResult'

const fileFormKey = 'invoice'
const maxUploadSize = 1e7

export const useInvoiceUpload = () => {
  const { request } = useAxios({ url: '/invoice/upload', method: 'POST' })
  const [isLoading, setIsLoading] = useState(false)
  const addAlert = useSetRecoilState(addAlertQuery)

  const uploadInvoice = async (file: File) => {
    if (file.size > maxUploadSize) {
      addAlert([{ message: 'File size to large' }])

      return
    }

    setIsLoading(true)

    const formdata = new FormData()
    formdata.append(fileFormKey, file)

    try {
      if (IS_LOCAL) {
        await timeoutResult(null, 1500)
      } else {
        await request({ input: formdata })
      }
      addAlert([{ message: 'Файл загружен', type: AlertType.SUCCESS }])
    } catch (err) {
      addAlert([{ message: err.response.data.message, duration: 5000 }])
    } finally {
      setIsLoading(false)
    }
  }
  return { isLoading, call: uploadInvoice }
}
